'use client';

import { useSearchParams } from 'next/navigation';
import { getValidModal } from './getValidModal.js';
/**
 * Modal util component used along with {@link Modal} to disable rendering of the rest of the page.
 *
 * @param root0 - Component props
 * @param root0.children the children to pass down
 * @param root0.modalTypes the list of available modaltypes to validate
 * ```tsx
 * &lt;ModalSidekick modalTypes={['login', 'register']}>
 * // main content
 * &lt;/ModalSidekick>
 * &lt;Modal>
 * // modal content (treated as its "own page")
 * &lt;/Modal>
 * ```
 * @returns Sidekick component.
 */
export default function ModalSidekick(t0) {
  const {
    children,
    modalTypes
  } = t0;
  const searchParams = useSearchParams();
  if (getValidModal(modalTypes, searchParams)) {
    return;
  }
  return children;
}